export default "__VITE_ASSET__l_0wJS2Q__"